import { useEffect, type MutableRefObject } from "react";
import { VideoPriorityBasedPolicy } from "amazon-chime-sdk-js";
import { updateDownlinkPreferences } from "@core/features/video";
import type { VideoSourceState } from "@core/features/video";
import { usePlatformStore } from "@platform/store";

/**
 * Syncs `activeSpeakers` into `videoSourceState.activeSpeakersWithCameraSource`
 * and calls `updateDownlinkPreferences` whenever speakers change.
 */
export function useActiveSpeakerDownlinkSync(
  policyRef: MutableRefObject<VideoPriorityBasedPolicy>
) {
  const activeSpeakers = usePlatformStore((s) => s.activeSpeakers);

  useEffect(() => {
    const s = usePlatformStore.getState();
    const { attendeeTileState, videoSourceState } = s;
    const { cameraSources } = videoSourceState;
    const activeSpeakersWithCameraSource: string[] = [];

    for (const attendeeId of activeSpeakers) {
      const ts = attendeeTileState[attendeeId];
      if (
        (ts === 'video' || ts === 'frozen') &&
        cameraSources.includes(attendeeId)
      ) {
        activeSpeakersWithCameraSource.push(attendeeId);
      }
    }

    const nextVideoSourceState: VideoSourceState = {
      ...videoSourceState,
      activeSpeakersWithCameraSource,
    };

    s.setVideoSourceState(nextVideoSourceState);
    updateDownlinkPreferences(
      { layout: s.layout },
      nextVideoSourceState,
      attendeeTileState,
      policyRef.current
    );
  }, [activeSpeakers]);
}
